import { getReportTypeFromDataType, getReportPathForType } from './utils';
import { WIDGET_DATA_TYPES } from './widgetDataTypes';
import { buildWidgetReportQueryForType } from '../containers/reportsWidgets/DashboardDimensionDrilldownPopover';
import { serializeReportQuery, getImpersonationFromQuery } from '../utils/url';

export function buildOpenInReportsUrl(widget, reportDates, displayUnenriched = false) {
    const reportType = getReportTypeFromDataType(widget.dataType, widget.type);
    const path = getReportPathForType(reportType);
    const dataTypeFields = (WIDGET_DATA_TYPES[widget.dataType] || {}).fields || {};
    const query = buildWidgetReportQueryForType(
        widget.query,
        reportType,
        dataTypeFields,
        reportDates,
        displayUnenriched
    );
    // Mirror the builders' null contract — no widget query, no URL to open.
    if (!query) {
        return null;
    }
    const serializedQuery = serializeReportQuery(query, null, null, null, null);

    const { href, hash } = window.location;
    const redirectHref = href.substring(0, href.indexOf(hash) + 1);
    const impersonationUser = getImpersonationFromQuery();
    let redirectUrl = `${redirectHref}${path}?${serializedQuery}`;
    if (impersonationUser) {
        redirectUrl += `&user=${encodeURIComponent(impersonationUser)}`;
    }
    return redirectUrl;
}
